import '../../style/index.less';
import './index.less';
// style dependencies
import '../../button/style';



// WEBPACK FOOTER //
// ./components/modal/style/index.tsx